;(function ($) {
  /* Currency */
  var bcCurrency = {
    convertCurrency : function(oldCurrency, newCurrency, selector, format){
      /* Saving the current price */
      $(selector).each(function() {
        $(this).attr('data-currency-' + oldCurrency.toLowerCase(), $(this).html());
      });

      /* Update currency */
      Currency.convertAll(oldCurrency, newCurrency, selector, format);
    }
  }
  
  /* Modal */
  var bcModal = {
    init : function(options){
      var defaults = {
        loading : '.loading-ajax',
        notify : '#notifyModal'
      }
      this.vars = $.extend({}, defaults, options);
    },
    
    showOverlay : function(){
    	$('body').addClass('overlay');
    },
    
    hideOverlay : function(){
      $('body').removeClass('overlay');
    },
    
    showLoading : function(){
      $(this.vars.loading).show();
    },
    
    showLoadingOverlay : function(){
      this.showOverlay();
      this.showLoading();
    },
    
    hideLoading : function(){
      $(this.vars.loading).hide();
    },
    
    hideLoadingOverlay : function(){
      this.hideOverlay();
      this.hideLoading();
    },
    
    showModal : function(msg){
    	
    },
    
    showModalOverlay : function(msg){
      this.showOverlay();
      this.showModal(msg);
    },
    
    showNotifyModal : function(msg){
      $(this.vars.notify + ' .row').html(msg);
      $(this.vars.notify).modal('show');
    }
  }
  
  /* Cart */
  $.bcCart = function(options) {
    var defaults = {
      counter : '#counter',
      btn_cart : '.btn-cart',
      btn_cart_detail : '.btn-cart-detail',
      money_format : '',
      cart_wrapper : '.cart-dropdown',
      modal_wrapper: '.layer-addcart-modal',
      remove_item : '.cart-dropdown .remove-control'
    }
    var vars = $.extend({}, defaults, options);
    
    this.init = function(){
      this.initEvent();
    }
    
    this.initEvent = function(){
      var me = this;
      this.initAddCartOnListPage();
      this.initAddCartOnDetailPage();
      $(document).on('cart.requestStarted', function(event, cart) {
        bcModal.showLoadingOverlay();
      });
      
      $(document).on('cart.requestComplete', function(event, cart) {
        Shopify.updateCartInfo(cart, 'cart-info', 'shopping-cart');
      });
      
      $(document).on('click', vars.remove_item ,function(e, target){
      	e.preventDefault();
        var id = $(this).attr('data-variant-id');
        me.doRemovingItem(id, me.notifyRemovingSuccess, me.notifyRemovingError);
      });
    }
    
    this.initAddCartOnListPage = function(){
      var me = this;
      $(document).on('click',vars.btn_cart,function(e){
        e.preventDefault();
        var id = $(this).attr('data-id');
        me.doAddingCart(id, 1, me.notifyAddingSuccess, me.notifyAddingError);
      });
    }
    
    this.initAddCartOnDetailPage = function(){
      var me = this;
      $(document).on('click',vars.btn_cart_detail,function(e){
      	e.preventDefault();
        /* Show loading */
        bcModal.showLoadingOverlay();

        var $this = $(this);

        $this.addClass('disabled');

        var form = $this.parents('form');

        // Hide Modal
        //$('.modal').modal('hide');

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: true,
          data: form.serialize(),
          dataType: 'json',
          error: me.notifyAddingError,
          success: function(jqXHR, textStatus, errorThrown){
            $this.removeClass('disabled');

            $.ajax({
              type: 'GET',
              url: '/cart.js',
              async: false,
              cache: false,
              dataType: 'json',
              success: function(data){
                data.image = jqXHR['image'];
                data.title = jqXHR['title'];
                data.qty = jqXHR['quantity'];
                data.price = jqXHR['price'];
                console.log(data);
                if($this.hasClass('in_quick_view')){
                  $('#quickViewModal').modal('hide');
                  setTimeout(function(){
                    me.notifyAddingSuccess(data, textStatus, jqXHR);
                  },500);
                } else {
                  me.notifyAddingSuccess(data, textStatus, jqXHR);
                }
              }
            });
            
            // Let's get the cart and show what's in it in the cart box.	
            Shopify.getCart(function(cart) {
              Shopify.updateCartInfo(cart, 'cart-info');		
            });
            
          },
          cache: false
        });
      });
    }
    
    /* Show notify after add to cart successfully */
    this.notifyAddingSuccess = function(data, textStatus, jqXHR){
      bcModal.hideLoading();
      var total = data.price * data.qty;
      var content = '<div class="layer-addcart-modal">';
      content += '<div class="layout-cart-img"><img class="fix-product-img" src="' + data.image + '"/></div>';
      content += '<div class="layout-cart-info">';
      content += '<h2><i class="fa fa-check"></i>Product successfully added to your shopping cart</h2>';
      content += '<p class="fix-title"><strong>Name: </strong>' + data.title + '</p>';
      content += '<p><strong>Quantity: </strong>' + data.qty + '</p>';
      content += '<p><strong>Total Price: </strong>' + (Shopify.formatMoney(total, vars.money_format)) + '</p>';
      content += '<div class="modal-button">';
      content += '<button type="button" class="btn btn-default" data-dismiss="modal">Continue Shopping</button>';
      content += '<a href="/checkout">Proceed to checkout</a>';
      content += '</div>';
      content += '</div>'
      content += '</div>';
      bcModal.showNotifyModal(content);
      
      if(Currency.cookie.read() != null){
        bcCurrency.convertCurrency(vars.currency, Currency.cookie.read(), vars.modal_wrapper + ' span.money', 'money_format');
      }
    }
      
    /* Show notify after add to cart error */
    this.notifyAddingError = function(jqXHR, textStatus, errorThrown) {
      bcModal.hideLoading();
      bcModal.showNotifyModal('Error: ' + errorThrown + '!');
    }
    
    /* Show notify after remove item from cart successfully */
    this.notifyRemovingSuccess = function(data, textStatus, jqXHR){
      bcModal.hideLoading();
    }
      
    /* Show notify after remove item from cart error */
    this.notifyRemovingError = function(jqXHR, textStatus, errorThrown) {
      bcModal.hideLoading();
      bcModal.showNotifyModal('Error: ' + errorThrown + '!');
    }
    
    /* Process adding product to cart */
    this.doAddingCart = function(variantId, qty, callbackSuccess, callbackError){
      CartJS.addItem(variantId, qty, {
        }, {
            "success": callbackSuccess,
            "error": callbackError
        });
    }
    
    this.doRemovingItem = function(variantId, callbackSuccess, callbackError){
      console.log(variantId);
      CartJS.removeItemById(variantId,{
        "success": callbackSuccess,
        "error": callbackError
      });
    }
    
    /* Update cart box after add to cart or remove item successfully */
    Shopify.updateCartInfo = function(cart, cart_summary_id, cart_count_id) {
		if ((typeof cart_summary_id) === 'string') {
			var cart_summary = jQuery('#' + cart_summary_id);
			if (cart_summary.length) {
				// Start from scratch.
				cart_summary.empty();
				// Pull it all out.

				jQuery.each(cart, function(key, value) {
					if (key === 'items') {
					var $html = '';
					
						if (value.length) {
						  $html += "<table><tbody>";
						  jQuery.each(value, function(i, item) {
							$html += '<tr>';
							$html += '<td class="product-thumb">';
							$html += '<a href="' + item.url + '"><img src="' + Shopify.resizeImage(item.image, 'small') + '"  alt="' + item.title + '" /></a>';
							$html += '</td>';
							$html += '<td>';
							$html += '<a href="' + item.url + '">';
							$html += '<strong>'+ item.title +'</strong>';
							$html += '</a>';
							$html += '</td>';
							$html += '<td>x' + item.quantity + '</td>'
							$html += '<td>' + Shopify.formatMoney(item.line_price, vars.money_format) + '</td>'
							$html += '<td>';
							$html += '<a a title="close" class="remove" href="javascript:;" onclick="Shopify.removeItem('+ item.variant_id +')"><i class="fa fa-close"></i></a>';
							$html += '</td>';
							$html += '</tr>';
						  });
						  $html += "</tbody></table>";
							
						  $html += '<div class="sub-total">'
								+	'<p><span>Total</span> <span id="total_cart">' + Shopify.formatMoney(cart.total_price, vars.money_format) + '</span></p>'
								+ '</div>';
						  $html += '<div class="cart-button">'
								+ '<a title="Shopping Cart" href="/cart">Shopping Cart</a>'
								+ '<a title="Checkout" href="/checkout">Checkout</a>'
								+ '</div>';     
						}
						else {
							$html = "<p>Your cart is currently empty.</p>";
						}
					
						/* Update currency */
						if(Currency.cookie.read() != null){
						  bcCurrency.convertCurrency(vars.currency, Currency.cookie.read(), vars.cart_wrapper + ' span.money', 'money_format');
						}
					
					}
				  
				  cart_summary.append($html);
				});
			}
		}
		// Update cart count.
		if ($('.num-items-in-cart .umbrella_number').length) {
			$('.num-items-in-cart .umbrella_number').html(cart.item_count);
		}
		// Update cart total price.
		if ($('.num-items-in-cart .total').length) {
			$('.num-items-in-cart .total').html(Shopify.formatMoney(cart.total_price, ""));
		}
	};
  
  
    // Update Cart
    Shopify.onCartUpdate = function(cart) {
      Shopify.updateCartInfo(cart, 'cart-info', 'shopping-cart');
    };
  
      
    this.init();
    
    $.fn.bcCart = function(options) {
		return this.each(function(){
			new $.bcCart(options);
		});
	}
  }
    
  /* Quick view */  
  $.bcQuickView = function(options) {
    var defaults = {
      var_name : {
      	title : 'BC_PRODUCT_NAME',
        desc : 'BC_PRODUCT_DESC',
        images_large : 'BC_PRODUCT_IMAGES_LARGE',
        images_thumb : 'BC_PRODUCT_IMAGES_THUMB',
        price : 'BC_PRODUCT_PRICE',
        subtotal : 'BC_SUBTOTAL',
        color_options : 'BC_COLOR_OPTIONS',
        bc_review : 'BC_REVIEW',
        bc_wishlist : 'BC_WISHLIST'
      },
      btn_control : '.btn_quickview',
      wrapper : '.quick-view-wrapper',
      money_format : '',
      currency : 'USD',
      product_sold_out_json : {},
      product_unavailable_html : {}
    }
    var vars = $.extend({}, defaults, options);
    this.tpl = $(vars.wrapper).html();
    this.init = function(){
      var me = this;
      $(document).on('click',vars.btn_control,function(e){
        e.preventDefault();
        var json = $(this).find('.json').text();
        var product = $.parseJSON(json);
        $('#quickViewModal .row').html(me.getUpdatedContent(product, $(this)));
        
        setTimeout(function() {
          $('#quickViewModal').modal('show');
        }, 1500);
        
        //$('#quickViewModal').modal('show');
        
        if($('.options-' + product.id).length > 0){
          new Shopify.OptionSelectors('quickview-product-select-' + product.id, {
            product: product,
            onVariantSelected: me.selectCallbackInQuickView,
            enableHistoryState: true
          });
        } else {
          /* Update currency */
          if(Currency.cookie.read() != null){
            bcCurrency.convertCurrency(vars.currency, Currency.cookie.read(), '#quickViewModal span.money', 'money_format');
          }
        }
        
        me.reInitZoom('#quickViewModal');
        
        $('#quickViewModal .qty').on('change', function(){
        	me.updateSubtotal('#quickViewModal ');
        });
        //updateSubtotal
        //$('body').append(me.getUpdatedContent(json));
      });
      
      $('.btn_quickview').on('click',function(){
        bcModal.showLoading();
      });
      
      $('#quickViewModal').on('shown.bs.modal',function(){
        
        bcModal.hideLoading();
        
      	// Product Slider
        setTimeout(function(){
        	$('.about-carousel').flexslider({
              animation: "slide",
              controlNav: false,
              animationLoop: false,
              slideshow: false,
              itemWidth: 100,
              itemMargin: 5,
              asNavFor: '.about-slider',
          });
          $('.about-slider').flexslider({
              animation: "fade",
              controlNav: false,
              animationLoop: false,
              slideshow: false,
              sync: ".about-carousel",
              directionNav: false
          });
        },0)
		
      });
    }
    
    this.getUpdatedContent = function(product, btn){
      var html = this.tpl;
      $.each( vars.var_name, function( key, value ) {
        if(key == 'images_large'){
          var image_html = '<div class="flexslider col-md-12 col-sm-12 col-xs-12 product-slider about-slider"><ul class="slides">';
          /*if(product.featured_image != undefined){
            image_html += '<li><img src="' + Shopify.resizeImage(product.featured_image, 'grande') + '"/></li>';
          }*/
          if(product.images.length > 0){
            $.each(product.images, function(key_img, img){
            	image_html += '<li><img src="' + Shopify.resizeImage(img, '1024x1024') + '" class="product-featured-image magniflier"/></li>';
            });
          }
          image_html += '</ul></div>';
          html = html.replace(new RegExp(value, 'g'),image_html);
        } else if(key == 'images_thumb'){
          var image_html = '<div class="col-md-12 col-sm-12 col-xs-12 flexslider product-thumb-horizontal no-padding about-carousel"><ul class="slides view-more">';
          /*if(product.featured_image != undefined){
            image_html += '<li><img src="' + Shopify.resizeImage(product.featured_image, 'thumb') + '"/></li>';
          }*/
          if(product.images.length > 0){
            $.each(product.images, function(key_img, img){
            	image_html += '<li><img src="' + Shopify.resizeImage(img, 'medium') + '"/></li>';
            });
          }
          image_html += '</ul></div>';
          html = html.replace(new RegExp(value, 'g'),image_html);
        } else if(key == 'desc' ){ 
          	html = html.replace(new RegExp(value, 'g'),btn.parents('.main-product').find('.desc').html());
        } else if(key == 'price') {
          	var price_html = '';
            if(product.available == true){
                if(product.price_varies){
                    var priceText = "From price";
                    price_html += priceText.replace('price',Shopify.formatMoney(product.price, vars.money_format));
                } else {
                    price_html += Shopify.formatMoney(product.price, vars.money_format);
                }
                if(product.compare_at_price_max > product.price){
                  price_html += '<del>' + Shopify.formatMoney(product.compare_at_price_max, vars.money_format) + '</del>';
                }
            } else {
                if(product.price_varies){
                    var priceText = 'From price';
                    price_html += priceText.replace('price',Shopify.formatMoney(product.price, vars.money_format));
                }
                price_html += 'Sold Out';
            }
            html = html.replace(new RegExp(value, 'g'),price_html);
        } else if(key == 'subtotal'){
          html = html.replace(new RegExp(value, 'g'),Shopify.formatMoney(product.price, vars.money_format));
        } else if(key == 'color_options'){
          if($('.options-' + product.id).length > 0){
            var options = $('.options-' + product.id).html().replace('product-select-qs','quickview-product-select-' + product.id)
          		.replace('<!--','').replace('-->','');
          	html = html.replace(new RegExp(value, 'g'),options);
          } else {
          	html = html.replace(new RegExp(value, 'g'),'');
          }
          
        } else if(key == 'bc_review'){
          html = html.replace(new RegExp(value, 'g'),'<span class="shopify-product-reviews-badge" data-id="' + product.id + '"></span>');
          //<span class="shopify-product-reviews-badge" data-id=""></span>
        } else if(key == 'bc_wishlist'){
          html = html.replace(new RegExp(value, 'g'),btn.parents('.inner-product').find('.wishlist_wrapper').html());
        } else {
            html = html.replace(new RegExp(value, 'g'),product[key]);
        }
      });
      return html;
    }
    
    this.getOptions = function(type, product){
      var optionIndex = 0, isValid = false, optionLabel;
      $.each(product.options,function(optionKey, optionValue){
        if((optionValue.toLowerCase() == 'color' && type == 'color') || (optionValue.toLowerCase() == 'size' && type == 'size')){
          optionIndex = optionKey;
          isValid = true;
          optionLabel = optionValue;
        }
      });
      if(isValid == true){
        var colorOptions = '<div class="swatch color clearfix" data-option-index="' + optionIndex +'">';
        colorOptions += '<div class="header">' + optionLabel + '</div>';
        var values = [];
        $.each(product.variants,function(variantKey, variantObj){
          var variantValue = variantObj.options[optionIndex];
          var variantValueHandle = variantValue.replace(new RegExp(' ', 'g'),'-').toLowerCase();
          if(!$.inArray(variantValue,values)){
            values.push(variantValue);
            colorOptions += '<div data-value="' + variantValue + '" class="swatch-element';
            if(type == 'color'){
            	colorOptions += ' color';
            }
            colorOptions += ' ' + variantValueHandle;
            if(variantObj.available == true){
              colorOptions += ' available">';
            } else {
              colorOptions += ' soldout">';
            }
            if(type == 'color'){
            	colorOptions += '<div class="tooltip">' + variantValue + '</div>';
            }
            colorOptions += '<input id="swatch-' + optionIndex + '-' + variantValueHandle + '" type="radio" name="option-'
            	+ optionIndex + '" value="' + variantValue + '"';
            if(variantKey == 0){
            	colorOptions += ' checked';
            }
            if(variantObj.available != true){
            	colorOptions += ' disabled';
            }
            colorOptions += '/>';
            if(type == 'color'){
            	colorOptions += '<label for="swatch-' + optionIndex + '-' + variantValueHandle + '" style="background-color:' + variantValueHandle + ';'
                + ' background-image: url(';
            }
            colorOptions += '</div>';
          }

        })
        colorOptions += '</div>';
      }
    }
    
    this.reInitZoom = function(wrapper){
      if( $(wrapper + " .magniflier").length ) {
        var native_width = 0;
        var native_height = 0;
        var mouse = {x: 0, y: 0};
        var magnify;
        var cur_img;

        var ui = {
          magniflier: $(wrapper + ' .magniflier')
        };

        // Add the magnifying glass
        if (ui.magniflier.length) {
          var div = document.createElement('div');
          div.setAttribute('class', 'glass');
          ui.glass = $(div);

          $('body').append(div);
        }


        // All the magnifying will happen on "mousemove"

        var mouseMove = function(e) {
          var $el = $(this);

          // Container offset relative to document
          var magnify_offset = cur_img.offset();

          // Mouse position relative to container
          // pageX/pageY - container's offsetLeft/offetTop
          mouse.x = e.pageX - magnify_offset.left;
          mouse.y = e.pageY - magnify_offset.top;

          // The Magnifying glass should only show up when the mouse is inside
          // It is important to note that attaching mouseout and then hiding
          // the glass wont work cuz mouse will never be out due to the glass
          // being inside the parent and having a higher z-index (positioned above)
          if (
            mouse.x < cur_img.width() &&
            mouse.y < cur_img.height() &&
            mouse.x > 0 &&
            mouse.y > 0
          ) {

            magnify(e);
          }
          else {
            ui.glass.fadeOut(100);
          }

          return;
        };

        var magnify = function(e) {

          // The background position of div.glass will be
          // changed according to the position
          // of the mouse over the img.magniflier
          //
          // So we will get the ratio of the pixel
          // under the mouse with respect
          // to the image and use that to position the
          // large image inside the magnifying glass

          var rx = Math.round(mouse.x/cur_img.width()*native_width - ui.glass.width()/2)*-1;
          var ry = Math.round(mouse.y/cur_img.height()*native_height - ui.glass.height()/2)*-1;
          var bg_pos = rx + "px " + ry + "px";

          // Calculate pos for magnifying glass
          //
          // Easy Logic: Deduct half of width/height
          // from mouse pos.

          // var glass_left = mouse.x - ui.glass.width() / 2;
          // var glass_top  = mouse.y - ui.glass.height() / 2;
          var glass_left = e.pageX - ui.glass.width() / 2;
          var glass_top  = e.pageY - ui.glass.height() / 2;
          //console.log(glass_left, glass_top, bg_pos)
          // Now, if you hover on the image, you should
          // see the magnifying glass in action
          ui.glass.css({
            left: glass_left,
            top: glass_top,
            backgroundPosition: bg_pos
          });

          return;
        };

        $(wrapper + ' .magniflier').on('mousemove', function() {
          ui.glass.fadeIn(100);

          cur_img = $(this);

          var large_img_loaded = cur_img.data('large-img-loaded');
          var src = cur_img.data('large') || cur_img.attr('src');

          // Set large-img-loaded to true
          // cur_img.data('large-img-loaded', true)

          if (src) {
            ui.glass.css({
              'background-image': 'url(' + src + ')',
              'background-repeat': 'no-repeat'
            });
          }

          // When the user hovers on the image, the script will first calculate
          // the native dimensions if they don't exist. Only after the native dimensions
          // are available, the script will show the zoomed version.
          //if(!native_width && !native_height) {

          if (!cur_img.data('native_width')) {
            // This will create a new image object with the same image as that in .small
            // We cannot directly get the dimensions from .small because of the 
            // width specified to 200px in the html. To get the actual dimensions we have
            // created this image object.
            var image_object = new Image();

            image_object.onload = function() {
              // This code is wrapped in the .load function which is important.
              // width and height of the object would return 0 if accessed before 
              // the image gets loaded.
              native_width = image_object.width;
              native_height = image_object.height;

              cur_img.data('native_width', native_width);
              cur_img.data('native_height', native_height);

              //console.log(native_width, native_height);

              mouseMove.apply(this, arguments);

              ui.glass.on('mousemove', mouseMove);
            };

            image_object.src = src;

            return;
          } else {

            native_width = cur_img.data('native_width');
            native_height = cur_img.data('native_height');
          }
          //}
          //console.log(native_width, native_height);

          mouseMove.apply(this, arguments);

          ui.glass.on('mousemove', mouseMove);
        });

        ui.glass.on('mouseout', function() {
          ui.glass.off('mousemove', mouseMove);
        });
      }
    }
    
    this.selectCallbackInQuickView = function(variant, selector) {
      if (variant) {
        var form = jQuery('#' + selector.domIdPrefix).closest('form');
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }

      }
      if (variant.featured_image) { 
        var originalImage = jQuery("#quickViewModal .product-featured-image");
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
          jQuery('#quickViewModal .view-more img').each(function() {
            var grandSize = jQuery(this).attr('src');
            grandSize = grandSize.replace('medium','1024x1024');
            newImageSizedSrc = newImageSizedSrc.replace('1024x1024','1024x1024');
            var tmp = newImageSizedSrc.split('?');
            console.log(grandSize);
            console.log(tmp[0]);
            if (grandSize == tmp[0]) {
              jQuery(this).parent().trigger('click');              
              return false;
            }
          });
        });   
      }
      if (variant && variant.available) {
        jQuery('.btn-cart-detail.in_quick_view').removeAttr('disabled').removeClass('disabled'); // remove unavailable class from add-to-cart button, and re-enable button
        if(variant.price < variant.compare_at_price){
          jQuery('#quickViewModal .amount').html(Shopify.formatMoney(variant.price, vars.money_format) + "<del>" + Shopify.formatMoney(variant.compare_at_price, vars.money_format) + "</del>");
        } else {
          jQuery('#quickViewModal .amount').html(Shopify.formatMoney(variant.price, vars.money_format));
        }
        /* Update currency */
        if(Currency.cookie.read() != null){
        	bcCurrency.convertCurrency(vars.currency, Currency.cookie.read(), '#quickViewModal span.money', 'money_format');
        }
      } else {
        jQuery('.btn-cart-detail.in_quick_view').addClass('disabled').attr('disabled', 'disabled'); // set add-to-cart button to unavailable class and disable button
        var message = variant ? vars.product_sold_out_json : vars.product_unavailable_html;
        jQuery('.btn-cart-detail.in_quick_view').html(message);
      }
    }
    
    /* Update subtotal after change quantity */
    this.updateSubtotal = function(wrapper) {
      var regex = /([0-9]+[.|,][0-9]+)/g;
      var unitPriceText = jQuery(wrapper + '.detail-price').text().match(regex)[0];
      var unitPrice = unitPriceText.replace(/[.|,]/,'');
      var quantity = 1;
      if($(wrapper + '.qty').val() != ''){
      	quantity = parseInt($(wrapper + '.qty').val());
      }
      var totalPrice = unitPrice * quantity;

      var totalPriceText = Shopify.formatMoney(totalPrice, vars.money_format);
      totalPriceText = totalPriceText.match(regex)[0];

      var regInput = new RegExp(unitPriceText, "g");  
      var totalPriceHtml = jQuery(wrapper + '.detail-price').html().replace(regInput ,totalPriceText).replace('amount','total-amount'); 

      jQuery(wrapper + '.order-total strong').html(totalPriceHtml);
    }
    
    this.init();
    
    $.fn.bcQuickView = function(options) {
      return this.each(function(){
        new $.bcQuickView(options);
      });
	}
  }
    
  // Wishlist
  $.bcWishlist = function(options) {
    var defaults = {
      btn_control : '.wl-add'
    }
    var vars = $.extend({}, defaults, options);
    
    this.init = function(){
      var me = this;
      $(document).on('click',vars.btn_control,function(e){

        bcModal.showLoading();

        var $this = $(this);
        $this.addClass('disabled');

        e.preventDefault();
        var form = $(this).parent('form');
        $.ajax({
          type: "POST",
          url: "/contact",
          data: form.serialize(),
          beforeSend: function() {
            //to do
          },
          success: function(n) {
			//product-box-inner
            bcModal.hideLoading();
            var content = '';
            if($this.parents('.form-add-wl').length > 0){/* Add to wishlist on list page */
              var json = $this.parents('.form-add-wl').find('span.json').text();
              console.log(json);
              var product = $.parseJSON(json);
              content = '<img class="fix-product-img" src="' + product.featured_image + '"/>';
              content += '<span class="fix-title">The product was successfully added to your wishlist</span>';
            }
            bcModal.showNotifyModal(content);

          },
          error: function() {
            // to do
          }
        })
      });
      
    }
    
    this.notifySuccess = function(msg){
    
    }
    
    this.init();
    
    $.fn.bcWishlist = function(options) {
      return this.each(function(){
        new $.bcWishlist(options);
      });
	}
  }
  
  
  bcModal.init();
  
})(jQuery);